import { Component, OnInit, ViewChild } from '@angular/core';
import { DxFormComponent } from 'devextreme-angular';
import validationEngine from 'devextreme/ui/validation_engine';
import { moduli } from '../../config';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { KarticaArtiklaService } from './kartica_artikla.service';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-kartica_artikla',
  templateUrl: './kartica_artikla.component.html',
  styleUrls: ['./kartica_artikla.component.scss']
})

export class KarticaArtiklaComponent implements OnInit {
  @ViewChild("artiklValidacija", { static: false }) artiklValidacija!: DxFormComponent;
  
  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  dokumenti: any = [];
  sveVrsteDokumenta: any = [];
  sifraDokumenta: any = 'SVE';
  skladista: any = [];
  idPoslovnica: any = 'all';
  sviArtikli: any = [];
  idArtikl: any = null //'all';
  poruka: string;
  datumOd: any = moment();
  datumOd_za_slanje: any = moment().format('YYYY-MM-DD');
  datumDo: any = moment();
  datumDo_za_slanje: any = moment().format('YYYY-MM-DD');
  isLoading: boolean = true;
  dozvoli_export: boolean = false;
  disableGumb: boolean = false;

  statusArray: any = [
    {status_vrijednost: 'Z', status_naziv: 'ZAVRŠENO'},
    {status_vrijednost: 'S', status_naziv: 'STORNIRANO'},
  ];

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: KarticaArtiklaService) {

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().karticaArtikla;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onCellPrepared(e) {
    //console.log(e);
    //console.log(e.rowType);
    //console.log(e.column.dataField);
    if (e.rowType === "data"){
      if(e.column.dataField === "za_stanje" && e.data.za_stanje > e.data.za_maximum){
        e.cellElement.style.fontWeight = "bold";
        e.cellElement.style.color = "red";
      }
      if(e.column.dataField === "za_stanje" && e.data.za_stanje < e.data.za_minimum){
        e.cellElement.style.fontWeight = "bold";
        e.cellElement.style.color = "red"
      }
    }
  }

  dohvatiVrsteDokumenta(){
    this.sveVrsteDokumenta = [];
		let podaciZaSlanje = {
			idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token
		};
		//console.log(podaciZaSlanje);
		this.service.vrstaDokumentaPopis(podaciZaSlanje).subscribe((res) => {
			//console.log(res);
			if (res.success === true) {
        let podaci = [];
        podaci.push({DV_SIFRA: 'SVE', DV_NAZIV: 'SVE'}, ...res.data);
        this.sveVrsteDokumenta = new DataSource({
          store: podaci
        });
			}
		});
  }

  dohvatiArtikle() {
		this.sviArtikli = [];
		let podaciZaSlanje = {
			idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token
		};
		//console.log(podaciZaSlanje);
		this.service.artiklPopis(podaciZaSlanje).subscribe((res) => {
			//console.log(res);
			if (res.success === true) {
        let podaci = [];
        podaci.push({ar_id: 'all', sifrainaziv: 'SVE'}, ...res.data);
        this.sviArtikli = new DataSource({
          store: res.data
        });
			}
		});
	}

  dohvatiSkladista() {
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token
    };
    //console.log(podaciZaSlanje);
    this.service.poslovnicaPopis(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.skladista = [];
      this.skladista = [{ idposlovnica: 'all', po_sifra: 'all', po_naziv: 'SVE', sifrainaziv: 'SVE' }];
      if (res.success == true) {
        for (let i = 0; i < res.data.length; i++) {
          this.skladista.push({
            idposlovnica: res.data[i].idposlovnica,
            po_sifra: res.data[i].po_sifra,
            po_naziv: res.data[i].po_naziv,
            sifrainaziv: res.data[i].sifrainaziv
          });
        }
      }
    });
  }

  onValueChangedDatumOd(e) {
    //console.log(e);
    this.datumOd = e.value;
    this.datumOd_za_slanje = moment(e.value).format('YYYY-MM-DD');
  }
  
  onValueChangedDatumDo(e) {
    //console.log(e);
    this.datumDo = e.value;
    this.datumDo_za_slanje = moment(e.value).format('YYYY-MM-DD');
  }

  onChangeVrsta(e){
    //console.log(e);
    //console.log(e.value);
    this.sifraDokumenta = e.value;
  }

  onChangeArtikl(e){
    //console.log(e);
    //console.log(e.value);
    this.idArtikl = e.value;
  }

  onChangeSkladiste(e){
    //console.log(e);
    //console.log(e.value);
    this.idPoslovnica = e.value;
  }

  pretrazi(){
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      datumod: this.datumOd_za_slanje, 
      datumdo: this.datumDo_za_slanje,
      dv_sifra: this.sifraDokumenta,
      idartikl: this.idArtikl,
      //ar_sifra: this.sifraartikla,
      idposlovnica: this.idPoslovnica,
      //grupirajpo: 'CIJENA'
    }
    //console.log(podaciZaSlanje);
    this.dokumenti = [];
    var result = validationEngine.validateGroup("artiklValidacija");
    //console.log(result);
    if (result.isValid === true) {
      this.poruka = 'Učitavanje...';
      this.disableGumb = true;
      this.service.izvjestajKarticaArtikla(podaciZaSlanje).subscribe(res=>{
        //console.log(res);
        this.disableGumb = false;
        if (res.success == true) {
          this.dokumenti = res.data;
        }
        
        if (this.dokumenti.length > 0) {
          this.poruka = 'Učitavanje...';
        } else {
          this.poruka = 'Nema podataka za prikaz!';
        }
      });
    }else {
      notify('Artikl je obavezno polje!', 'error');
    }
  }


  ngOnInit(): void {
    this.dohvatiVrsteDokumenta();
    this.dohvatiArtikle();
    this.dohvatiSkladista();
  }

}